import {useQuery} from "react-query";
import apis from "services";
import {getMessages, unselectMessages} from "redux/actions";
import {useDispatch, useSelector} from "react-redux";
import {get} from "lodash";
import {useParams} from "react-router-dom";
import {useEffect} from "react";
import EventEmitter from "reactjs-eventemitter";

export default function useFetchMessages() {
    const {tab} = useParams();
    const dispatch = useDispatch()

    const {pageNumber, sort, pageLimit} = useSelector(state => state.inbox);

    const {data, isLoading, isFetching, refetch} = useQuery(
        ['messages', tab, pageNumber, pageLimit, sort],
        apis.messagesApi,
        {
            onSuccess: ({data}) => {
                dispatch(getMessages(data));
                dispatch(unselectMessages());
            }
        }
    );

    useEffect(() => {
        EventEmitter.subscribe('refetch-messages', async () => {
            await refetch();
        })
    }, [refetch])


    const messages = get(data, 'data.rows', []);

    const fetchingMessages = isLoading || isFetching

    return [
        fetchingMessages,
        messages
    ]
}